import { Flex, Grid } from 'ui';
import { Breadcrumbs, Panel } from 'components';
import { paths } from 'routes';
import { useQueryImportLogs } from 'graphql/query/useQueryImportLogs';
import { ImportLogsFilter, ImportLogsTable } from './components';
import { useImportLogsFilters } from './hooks/useImportLogsFilters';

export const ImportLogs = () => {
  const { handlers, filters, options } = useImportLogsFilters();
  const { data, loading } = useQueryImportLogs({
    variables: {
      importer: filters.selectedImporter,
    },
  });

  const importLogsData = data?.importLogs?.items ?? [];

  return (
    <Grid gridTemplateRows="40px 1fr">
      <Breadcrumbs
        px="s30"
        items={[
          { label: 'Home', to: paths.base },
          { label: 'Import Logs', to: paths.main.importLogs },
        ]}
      />

      <Flex flexDirection="column">
        <Panel label="Search & Filter">
          <ImportLogsFilter
            handlers={handlers}
            filters={filters}
            options={options}
          />
        </Panel>
        <Panel expandable={false} label="IMPORT LOGS">
          <ImportLogsTable data={importLogsData} loading={loading} />
        </Panel>
      </Flex>
    </Grid>
  );
};
